import api from "./axios";

export async function subscribeStorefrontPush(subscription, preferences = {}) {
  const { data } = await api.post("/public/push/subscribe", {
    subscription,
    preferences,
  });
  return data;
}

export async function unsubscribeStorefrontPush(endpoint) {
  const { data } = await api.delete("/public/push/subscribe", {
    data: { endpoint },
  });
  return data;
}
